import React from 'react';
import { useScrollReveal } from '../../hooks/useScrollReveal';

const SectionHeader = ({ title, description, icon, className }) => {

    const [ref, isVisible] = useScrollReveal();
    const revealClass = `scroll-reveal${isVisible ? ' visible' : ''}`;
    const surroundingClassName = `flex flex-col w-full mb-10 text-center ${className || ''} ${revealClass}`.trim()

    return <div ref={ref} className={surroundingClassName}>
        <div className='mx-auto inline-block w-10 mb-4'>
            {icon}
        </div>
        <h1 className="sm:text-4xl text-3xl font-medium title-font mb-4 text-white">
            {title}
        </h1>
        <div className="section-header-line" />
        <p className="lg:w-2/3 mx-auto leading-relaxed text-base mt-4">
            {description}
        </p>
    </div>
}

export default SectionHeader;